import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { take, tap } from 'rxjs/operators';
import { LOGSEVERITY, LOGTYPE } from '@core/app.costants';
import { PermissionsService } from '../permissions.service';
import { WatchdogService } from '@services/watchdog.service';
import { PermissionAddAction, PermissionAddedAction, PermissionErrorAddingAction, PermissionErrorRemovingAction, PermissionErrorUpdatingAction, PermissionRemoveAction, PermissionRemovedAction, PermissionUpdateAction, PermissionUpdatedAction } from './permisssion.actions';
import { selectSituazioniRuoli } from '../../roles/store/role.selector';
import { IStoreState } from '@core/store/store.state';

@Injectable()
export class PermissionEffects {
  constructor(
    private actions$: Actions,
    private permissionsHttpService: PermissionsService,
    private router: Router,
    private watchdog: WatchdogService,
    private store: Store<IStoreState>
  ) { }

  addPermission$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PermissionAddAction),
      tap((action) =>
        this.permissionsHttpService.addPermission(action.permission).subscribe({
          next: value => {
            this.store.dispatch(PermissionAddedAction({ permission: value }));

            this.watchdog.writeWatchdog({
              type: LOGTYPE.INFO,
              severity: LOGSEVERITY.NONE,
              message: `E' stato aggiunto il permesso ${action.permission.permesso} con id ${action.permission.id_permesso}`,
            });

            this.router.navigate(['/private-area', 'permissions']);
          }, error: err => {
            this.watchdog.writeWatchdog({
              type: LOGTYPE.ERROR,
              severity: LOGSEVERITY.HIGHT,
              message: `Si è verificato un problema durante l'aggiunta del permesso ${action.permission.permesso}`,
            });
            this.store.dispatch(PermissionErrorAddingAction());
          }
        })
      )
    ), { dispatch: false }
  );

  removePermission$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PermissionRemoveAction),
      tap((action) =>
        this.permissionsHttpService.removePermission(action.permissionId).subscribe({
          next: value => {
            this.store.dispatch(PermissionRemovedAction({ permissionId: value }));

            this.watchdog.writeWatchdog({
              type: LOGTYPE.INFO,
              severity: LOGSEVERITY.HIGHT,
              message: `E' stato rimosso il permesso ${action.permissionId}`,
            });

            this.router.navigate(['/private-area', 'permissions']);
          }, error: err => {
            this.watchdog.writeWatchdog({
              type: LOGTYPE.ERROR,
              severity: LOGSEVERITY.HIGHT,
              message: `Si è verificato un problema durante l'eliminazione del permess ${action.permissionId}`,
            });
            this.store.dispatch(PermissionErrorRemovingAction());
          }
        })
      )
    ), { dispatch: false }
  );

  updatePermission$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PermissionUpdateAction),
      tap((action) =>
        this.permissionsHttpService.updatePermission(action.permission).subscribe({
          next: value => {
            this.store.dispatch(PermissionUpdatedAction({ permission: value }))

            this.watchdog.writeWatchdog({
              type: LOGTYPE.INFO,
              severity: LOGSEVERITY.NONE,
              message: `E' stato aggiornato il permesso ${action.permission.id_permesso}`,
            });

            this.router.navigate(['/private-area', 'permissions']);
          }, error: err => {
            this.watchdog.writeWatchdog({
              type: LOGTYPE.ERROR,
              severity: LOGSEVERITY.HIGHT,
              message: `Si è verificato un errore durante l'aggiornamento del permesso ${action.permission.id_permesso}`,
            });
            this.store.dispatch(PermissionErrorUpdatingAction());
          }
        })
      )
    ), { dispatch: false }
  );
}
